import { forwardRef, type Ref, type SVGProps } from "react";
const IconPhotosOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path fill="currentColor" d="M13 9a2 2 0 1 0 0 4 2 2 0 1 0 0-4" />
    <path
      fill="currentColor"
      d="M28 5H8a2.006 2.006 0 0 0-2 2v3H4a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h19a2.006 2.006 0 0 0 2-2v-2h3a2.006 2.006 0 0 0 2-2V7a2.006 2.006 0 0 0-2-2m-5 21H4V12h2v10a2.006 2.006 0 0 0 2 2h15Zm5-4H12.414L18 16.414l3.293 3.293a1 1 0 0 0 1.414-1.414L22.414 18 25 15.414l3 3Zm0-6.414-2.293-2.293a1 1 0 0 0-1.414 0L21 16.586l-2.293-2.293a1 1 0 0 0-1.414 0L9.586 22H8V7h20Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPhotosOutlineSVG);
ForwardRef.displayName = "IconPhotosOutline";
export { ForwardRef as IconPhotosOutline };
